import React from "react";
import { createUseStyles, useTheme } from "react-jss";

import { PageInner } from "components/PageContainers";
import Button from 'components/Button';

const useStyles = createUseStyles(theme => ({
  wrapper: {
    marginTop: '8rem',
    padding: '3rem 1.2rem',
    [`@media(min-width: ${theme.breakpoints.medium.min})`]: {
      padding: '4rem 5rem'
    },
    [`@media(min-width: ${theme.breakpoints.large.min})`]: {
      marginTop: '10rem'
    },
  },
  pageInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    [`@media(min-width: ${theme.breakpoints.xLarge})`]: {
      display: 'flex'
    }
  },
  h2: {
    fontSize: '2.5rem',
    fontWeight: 600
  },
  button: {
    marginTop: '3rem',
  },
}));

export const SimpleCTASection = ({ background, children, className }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  return (
    <div style={{ background }} className={`${styles.wrapper} ${className}`}>
      <PageInner className={styles.pageInner}>
        {children}
      </PageInner>
    </div>
  )
};

export const SimpleCTASectionHeader = ({ children, className }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  return <h2 className={`${styles.h2} ${className}`}>{children}</h2>;
};


export const SimpleCTASectionButton = ({ children, className, ...rest }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  return <Button btnSize="wide" className={`${styles.button} ${className}`} {...rest}>{children}</Button>
};